import { initializeApp } from "firebase/app";
import { getFirestore, collection, addDoc, getDocs, getDoc, doc, query, where, updateDoc, setDoc } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyDQxO_tdQW38bt6AkxVBjlohwQ7zR_COGc",
  authDomain: "aylatravel.firebaseapp.com",
  projectId: "aylatravel",
  storageBucket: "aylatravel.firebasestorage.app",
  messagingSenderId: "898223611883",
  appId: "1:898223611883:web:8e76ba02e94f526a7e83ae"
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

export function addItem(table, data){
  return new Promise((resolve, reject) => {
    addDoc(collection(db, String(table)), data)
      .then(data => {
        resolve(data)
      })
      .catch(err => {
        reject(err)
      })
  })
}

export function getItems(table){
  return new Promise((resolve, reject) => {
    getDocs(collection(db, String(table)))
      .then(data => {
        let arrayList =[];
        data.forEach(item => {
          arrayList.push({ id: item.id, ...item.data() });
          resolve(arrayList);
        })
      })
      .catch(err => {
        reject(err)
      })
  })
}


